import { Box, Button, CircularProgress, IconButton, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useFieldValue } from "./NestedField";
import { mapUrl } from "util/geolocation";
import useNotification from "notification";
import { useState } from "react";
import ReplayIcon from "@mui/icons-material/Replay";
var deniedCount = 0;
export default function GeolocationButton({ name, label = "Mapa", icon = false, buttonProps, ...props }) {
    const [value, setValue] = useFieldValue(name);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const { showError, showSuccess } = useNotification();

    const getLocation = () => {
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setValue({ lat: position.coords.latitude, lng: position.coords.longitude });
                setLoading(false);
                showSuccess("Localização Obtida!");
                setError(null);
            },
            (error) => {
                console.log("error", error);
                if (error.code === 2 || error.code === 1) {
                    showError("O app não tem permissão para usar a localização");
                    setError("O app não tem permissão para usar a localização");
                    setLoading(false);
                    requestAuthorization();
                } else {
                    showError(
                        "Localização indisponível! Certifique-se de ativar a Localização. Desative o modo Avião."
                    );
                    setError(
                        "Localização indisponível! Certifique-se de ativar a Localização. Desative o modo Avião."
                    );

                    setLoading(false);
                }
            },
            { timeout: 40000, enableHighAccuracy: true }
        );
    };
    function requestAuthorization() {
        window.cordova.plugins.diagnostic.requestLocationAuthorization(evaluateAuthorizationStatus, (error) => {
            console.error("The following error occurred: " + error);
        });
    }
    function evaluateAuthorizationStatus(status) {
        console.log("evaluateAuthorizationStatus", status);
        // eslint-disable-next-line default-case
        switch (status) {
            case window.cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED:
                console.log("Permission not requested");
                requestAuthorization();
                break;
            case window.cordova.plugins.diagnostic.permissionStatus.DENIED:
                console.log("Permission denied");
                if (deniedCount < 3) {
                    deniedCount++;
                    requestAuthorization();
                } else {
                    // Are we sure we want to hassle the user more than 3 times?
                }
                break;
            case window.cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                console.log("Permission permanently denied");
                navigator.notification.confirm(
                    "Esta aplicação foi negada acesso à sua localização e realmente precisa dela para funcionar corretamente. Gostaria de ir para a página de configurações do aplicativo para permitir o acesso?",
                    function (i) {
                        if (i === 1) {
                            window.cordova.plugins.diagnostic.switchToSettings();
                        }
                    },
                    "Acesso à localização negado",
                    ["Sim", "Não"]
                );
                break;
            case window.cordova.plugins.diagnostic.permissionStatus.GRANTED:
                console.log("Permission granted always");
                // Yay! use location
                break;
            case window.cordova.plugins.diagnostic.permissionStatus.GRANTED_WHEN_IN_USE:
                console.log("Permission granted in use");
                // navigator.notification.confirm(
                //     "Esta aplicação foi negada acesso à sua localização e realmente precisa dela para funcionar corretamente. Gostaria de ir para a página de configurações do aplicativo para permitir o acesso?",
                //     function (i) {
                //         if (i === 1) {
                //             window.cordova.plugins.diagnostic.switchToSettings();
                //         }
                //     },
                //     "Acesso à localização em uso",
                //     ["Sim", "Não"]
                // );
                // Yay! use location
                break;
        }
    }

    const link = {
        href: mapUrl(value),
        target: "_blank",
    };

    if (value) {
        return (
            <Box sx={{ display: "inline-flex", flexDirection: "row", alignItems: "center" }}>
                {icon ? (
                    <>
                        {label ? <Typography>{label}</Typography> : null}

                        <IconButton title={label} {...link} color="primary" {...buttonProps}>
                            <LocationOnIcon />
                        </IconButton>
                    </>
                ) : (
                    <Button startIcon={<LocationOnIcon />} {...link} {...buttonProps}>
                        {label}
                    </Button>
                )}
            </Box>
        );
    } else {
        return (
            <>
                {loading ? (
                    ""
                ) : (
                    <div style={{ color: "red" }}>
                        * Sem Localização
                        {error && <div>{error}</div>}
                    </div>
                )}

                <Button onClick={getLocation} variant="contained" disabled={loading} color="primary">
                    {loading ? "" : <div style={{}}>Obter Localização</div>}
                    {loading ? <CircularProgress /> : <ReplayIcon />}
                </Button>
            </>
        );
    }
}
